import React from 'react';
import { GROUP_ROLE_TEMPLATES } from '../../constants/groupRoleTemplates';
import { summarizePageConfiguration } from '../../utils/pageConfigurationSummary';

export const ROLE_TEMPLATES_PANEL_ID = '__role-templates__';

const PAGE_LABELS = {
  dashboard: 'Dashboard',
  groups: 'Groups',
  profile: 'Profile',
  'user-profiles': 'User Profiles'
};

const pageLabel = (pageName) => PAGE_LABELS[pageName] || pageName;

const RoleTemplatesReference = ({ knownPages = [] }) => {
  const labelById = React.useMemo(() => {
    const map = new Map(Object.entries(PAGE_LABELS));
    (knownPages || []).forEach((p) => {
      if (p?.id) map.set(p.id, p.label || p.id);
    });
    return map;
  }, [knownPages]);

  return (
    <div className="ppm-role-templates-panel">
      <p className="ppm-role-templates-panel-intro">
        Bundles applied from Groups → Create team → Role template. Each writes{' '}
        <code>page_configuration</code> rows to the new team&apos;s groups_periods grantee.
      </p>
      <div className="ppm-role-templates-grid">
        {GROUP_ROLE_TEMPLATES.map((template) => (
          <article key={template.id} className="ppm-role-template-card">
            <header className="ppm-role-template-card-header">
              <h3 className="ppm-role-template-card-title">{template.label}</h3>
              <span className="ppm-role-template-card-id">{template.id}</span>
            </header>
            {template.description && (
              <p className="ppm-role-template-card-desc">{template.description}</p>
            )}
            {template.resolveGroupIdExcludesFromNames?.length > 0 && (
              <p className="ppm-role-template-card-note">
                Hides teams matching{' '}
                <strong>{template.resolveGroupIdExcludesFromNames.join(', ')}</strong>
              </p>
            )}
            <ul className="ppm-role-template-perms">
              {template.permissions.map((perm) => (
                <li key={`${template.id}-${perm.page_name}`} className="ppm-role-template-perm">
                  <span className="ppm-role-template-perm-page">
                    {labelById.get(perm.page_name) || pageLabel(perm.page_name)}
                  </span>
                  <span className="ppm-role-template-perm-config">
                    {summarizePageConfiguration(perm.configuration, {
                      pageName: perm.page_name
                    })}
                  </span>
                </li>
              ))}
            </ul>
          </article>
        ))}
      </div>
    </div>
  );
};

export default RoleTemplatesReference;
